import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "@/store";
import "./style/tailwindcss.css";
import '@/validate/validate'
import mapBoxGl from 'mapbox-gl'
import * as turf from '@turf/turf'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import { Stepper,Toast,Dialog,Popup,SwipeCell, Lazyload, Icon, Button, Loading, NoticeBar, Notify, List, Empty, Popover, Form, Field } from 'vant';
import mixpanel from "mixpanel-browser";
import VueCountryIntl from 'vue-country-intl';
// 引入css
import 'vue-country-intl/lib/vue-country-intl.css'
// 全局注册组件
Vue.component(VueCountryIntl.name, VueCountryIntl);

// Near entry of your product, init Mixpanel
mixpanel.init("1449abffcd72717f492bd51d21acc380", {
  debug: false,
  track_pageview: true,
  autocapture: true,
  persistence: "localStorage",
});
Vue.use(Lazyload,{
  loading: require('@/assets/action/default1.png'),
  error: require('@/assets/action/default1.png'),
});
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
Vue.prototype.$turf = turf
Vue.prototype.$mapboxgl = mapBoxGl
Vue.config.productionTip = false;
Vue.use(Stepper);
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(Popup).use(Form).use(Field);
Vue.use(SwipeCell).use(Icon).use(Button).use(Loading).use(NoticeBar).use(Notify).use(List).use(Empty).use(Popover);

Vue.prototype.$globalWeb = window.location.host;
new Vue({
  router,
  store,
  beforeCreate() {
    // Vue.prototype.$API = API;
  },
  render: (h) => h(App),
}).$mount("#app");
